import {
  MOSCOW_AREA_REGION_ID,
  MOSCOW_REGION_ID,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_REGION_ID,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
} from './geo';

export interface IMenuLink {
  name: string;
  title: string;
  trackingLabel?: string;
  path?: string[];
  section?: string;
  regionIds?: number[];
}

export const MENU_LINKS: IMenuLink[] = [
  {
    name: 'rent',
    title: 'Аренда',
    trackingLabel: 'rent',
    path: ['listingLinks', 'rent'],
    section: 'rent',
  },
  {
    name: 'sale',
    title: 'Продажа',
    trackingLabel: 'sale',
    path: ['listingLinks', 'sale'],
    section: 'sale',
  },
  {
    name: 'dealRent',
    title: 'Сдай/Сними',
    trackingLabel: 'dealRent',
    path: ['listingLinks', 'dealRent'],
    section: 'dealRent',
    regionIds: [
      MOSCOW_REGION_ID,
      ST_PETERSBURG_REGION_ID,
      MOSCOW_AREA_REGION_ID,
      ST_PETERSBURG_AREA_REGION_ID,
      MOSCOW_WITH_AREA_REGION_ID,
      ST_PETERSBURG_WITH_AREA_REGION_ID,
    ],
  },
  {
    name: 'newbuildings',
    title: 'Новостройки',
    trackingLabel: 'newobjects',
    path: ['listingLinks', 'newobjects'],
    section: 'new-buildings',
  },
  {
    name: 'commercial',
    title: 'Коммерческая',
    trackingLabel: 'commercial',
    path: ['listingLinks', 'commercial'],
    section: 'commercial',
  },
  {
    name: 'calculator',
    title: 'Оценка',
    trackingLabel: 'estimation',
    path: ['otherLinks', 'calculator'],
    section: 'valuation',
  },
  {
    name: 'mortgage',
    title: 'Ипотека',
    trackingLabel: 'mortgage',
    path: ['mortgageLinks', 'main'],
  },
  {
    name: 'additional1024px',
    title: 'Ещё',
  },
  {
    name: 'additional1093px',
    title: 'Ещё',
  },
];
